import { useField } from 'formik';
import { TextField, MenuItem } from '@mui/material';

const MySelectInput = ({ label, options, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <TextField
      select
      fullWidth
      label={label}
      {...field}
      error={meta.touched && Boolean(meta.error)}
      helperText={meta.touched && meta.error}
    >
      {options.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default MySelectInput;
